import { Component } from "@angular/core";

@Component({
  templateUrl: "./audienceQuestionConfirm.html"
})

export class AudienceQuestionConfirmComponent {
  message = "Thanks for asking your question. We will consider your response.";
}
